import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import { useMount } from '@perpay-web/hooks/useMount';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './DirectDepositDrawerMetal.scss';

const DirectDepositDrawerMetal = ({ className, onClose, onMount }) => {
    useMount(onMount);

    return (
        <BottomSheet
            className={getClassName(styles.modal, className)}
            onClose={onClose}
        >
            <div className={styles['copy-container']}>
                <div className={styles.header}>
                    How direct deposit works at Perpay
                </div>

                <div className={styles.copy}>
                    <ul className={styles.list}>
                        <li className={styles['list-item']}>
                            <div className={styles['dollar-card-icon']} />
                            <div className={styles['list-item--text']}>
                                Each payday, the amount you set will
                                automatically deposit to your Perpay account.
                            </div>
                        </li>
                        <li className={styles['list-item']}>
                            <div className={styles['mastercard-card-icon']} />
                            <div className={styles['list-item--text']}>
                                You can use each direct deposit of your paycheck
                                to pay down your card balance.
                            </div>
                        </li>
                        <li className={styles['list-item']}>
                            <div
                                className={styles['trending-bar-graph-icon']}
                            />
                            <div className={styles['list-item--text']}>
                                Direct deposit payments are effortless and help
                                to build credit with automatic transfers
                                enabled.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </BottomSheet>
    );
};

export default DirectDepositDrawerMetal;
